import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import useAppUser from 'hooks/useAppUser';
import {
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';

const useIsPropertyGuidebookEnabled = () => {
  const { isEmployee } = useAppUser();
  const { data } = useFetchIntegrationAgencySettings({
    enumId: IntegrationEnum.HOSTFULLY,
    enabled: isEmployee,
  });

  return data?.agencySettings?.status === IntegrationStatus.ACTIVE;
};

export default useIsPropertyGuidebookEnabled;
